import { Injectable } from '@angular/core';
import {AuthHttp} from '../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../environments/environment';

@Injectable()
export class GlobalServicesService {
  private route = 'global-service-schedule';
  constructor(private http: AuthHttp) { }

  public getServices(limit: number = 10, page = 1, orderBy = 'event_order', direction = 'asc') {
    return this.http.get(`${environment.baseUrl}${this.route}` +
      `?limit=${limit}&page=${page}&orderBy=${orderBy}&direction=${direction}`)
      .map(res => res.json()).toPromise();
  }
  public updateServicesOrder(reorderedServices) {
    return this.http.post(`${environment.baseUrl}${this.route}/update-services-order`, reorderedServices).toPromise();
  }
  public updateServicesTime(updatedService) {
    return this.http.post(`${environment.baseUrl}${this.route}/update-services-time`, updatedService).toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/global-service-schedule/services/global-services.service.ts